// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  .v-validate-pristine--style, v-password.v-validate-pristine:has(> .v-component-container > p-password.ng-invalid) input,
  v-password > .v-component-container > p-password.ng-dirty.ng-invalid input, .v-formControl.v-validate-pristine .ng-invalid.v-component-container, .v-formControl.v-validate-pristine .ng-invalid.p-component,
  .v-formControl .ng-invalid.ng-dirty.v-component-container,
  .v-formControl .ng-invalid.ng-dirty.p-component {
    --dropdown-border: 1px solid var(--gc-color-danger);
    border-color: var(--gc-color-danger) !important;
    outline: solid 1px var(--gc-color-danger);
    outline-offset: -4px;
  }
  .v-required .v-component-label:after,
  .v-formControl.v-required .v-component-label:after {
    content: "*";
    margin-left: 0.25rem;
    color: var(--gc-color-danger);
  }
  .v-readonly, .v-readonly input {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  v-password p-password {
    display: grid;
  }
  v-password p-password input {
    width: var(--password-width-full);
  }
  v-password .v-component-container.full {
    width: var(--password-width-full);
  }
  v-password .size-small {
    width: var(--password-width-small) !important;
  }
  v-password .size-medium {
    width: var(--password-width-medium) !important;
  }
  v-password .size-large {
    width: var(--password-width-large) !important;
  }
  v-password .size-full {
    width: var(--password-width-full) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/validation.sass","webpack://./src/app/modules/wrappers/lib/password/password.component.sass"],"names":[],"mappings":"AAAA;EACI;;;;IACI,mDAAA;IACA,+CAAA;IACA,yCAAA;IACA,oBAAA;ECIN;EDFE;;IAEI,YAAA;IACA,oBAAA;IACA,6BAAA;ECIN;EDEE;IACI,yBAAA;YAAA,iBAAA;IACA,oBAAA;ECAN;AACF;AAlBA;EAEQ;IACI,aAAA;EAmBV;EAlBU;IACI,iCAAA;EAoBd;EAjBU;IACI,iCAAA;EAmBd;EAZU;IACI,6CAAA;EAcd;EAbU;IACI,8CAAA;EAed;EAdU;IACI,6CAAA;EAgBd;EAfU;IACI,4CAAA;EAiBd;AACF","sourcesContent":["@layer vierkant\n    .v-validate-pristine--style\n        --dropdown-border: 1px solid var(--gc-color-danger)\n        border-color: var(--gc-color-danger) !important\n        outline: solid 1px var(--gc-color-danger)\n        outline-offset: -4px\n\n    .v-required .v-component-label:after,\n    .v-formControl.v-required .v-component-label:after\n        content: '*'\n        margin-left: 0.25rem\n        color: var(--gc-color-danger)\n    .v-formControl.v-validate-pristine .ng-invalid, \n    .v-formControl .ng-invalid.ng-dirty\n        &.v-component-container, &.p-component\n            @extend .v-validate-pristine--style    \n\n    .v-readonly, .v-readonly input\n        user-select: none\n        pointer-events: none","@use '../validation.sass'\n\n@layer vierkant\n    v-password\n        p-password\n            display: grid\n            input \n                width: var(--password-width-full)\n\n        .v-component-container\n            &.full\n                width: var(--password-width-full)\n\n        &.v-validate-pristine:has(> .v-component-container > p-password.ng-invalid) input, \n        > .v-component-container > p-password.ng-dirty.ng-invalid input\n            @extend .v-validate-pristine--style    \n\n        .size-\n            &small\n                width: var(--password-width-small) !important\n            &medium\n                width: var(--password-width-medium) !important\n            &large\n                width: var(--password-width-large) !important\n            &full\n                width: var(--password-width-full) !important"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
